namespace Matrix.Workflow {
    export interface RunBookRow {
        StepId?: number;
        StepCode?: string;
        StepDescription?: string;
        SourceName?: string;
        SourceCode?: string;
        ExpectedWhen?: string;
        QueuedWhen?: string;
        StartedWhen?: string;
        FinishedWhen?: string;
        ForceTrigger?: boolean;
        FunctionName?: string;
        SortOrder?: number;
        Dependencies?: string;
        Enabled?: boolean;
        ForceTriggerEnabled?: boolean;
        CustomLabel?: string;
        FunctionParameters?: string;
        StatusCode?: string;
        GroupName?: string;
        StdOut?: string;
        StdErr?: string;
        WorkflowInstanceId?: number;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace RunBookRow {
        export const idProperty = 'StepId';
        export const nameProperty = 'StepCode';
        export const localTextPrefix = 'Workflow.RunBook';
        export const deletePermission = 'DataAdmin:Runbook';
        export const insertPermission = 'DataAdmin:Runbook';
        export const readPermission = 'DataAdmin:Runbook';
        export const updatePermission = 'DataAdmin:Runbook';

        export declare const enum Fields {
            StepId = "StepId",
            StepCode = "StepCode",
            StepDescription = "StepDescription",
            SourceName = "SourceName",
            SourceCode = "SourceCode",
            ExpectedWhen = "ExpectedWhen",
            QueuedWhen = "QueuedWhen",
            StartedWhen = "StartedWhen",
            FinishedWhen = "FinishedWhen",
            ForceTrigger = "ForceTrigger",
            FunctionName = "FunctionName",
            SortOrder = "SortOrder",
            Dependencies = "Dependencies",
            Enabled = "Enabled",
            ForceTriggerEnabled = "ForceTriggerEnabled",
            CustomLabel = "CustomLabel",
            FunctionParameters = "FunctionParameters",
            StatusCode = "StatusCode",
            GroupName = "GroupName",
            StdOut = "StdOut",
            StdErr = "StdErr",
            WorkflowInstanceId = "WorkflowInstanceId",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
